import React from 'react';
import './LandingPage.css';

const LandingPage = () => {
  const handleJoinClick = () => {
    alert("Not ready for sign ups yet");
    // window.location.href = '/signup';
  };

  return (
    <div className="landing-page">

      {/* -------------------------
          Hero
      ------------------------- */}

      <header className="hero">

        <div className="header-top">

          <div className="logo">
            MyAIWeb
          </div>

          <div className="auth-buttons">

            <a href="/login" className="auth-btn">
              Login
            </a>

            <a href="/" className="auth-btn primary">
              Sign Up
            </a>

          </div>

        </div>


        <div className="hero-content">

          <div className="eyebrow">
            A different way to build with AI
          </div>

          <h1>
            Build Visually.<br />
            Create Your Own Way.
          </h1>

          <div className="ai-statement">
            AI works inside your design — not instead of it.
          </div>

          <p className="hero-description">
            Create your layout yourself, then bring AI into the areas
            you choose to create content, images, code and interactive
            experiences.
          </p>

          <p className="hero-explanation">
            You decide where things go. AI works within your design.
            Your page stays yours.
          </p>

          <a
            href="https://ait.myaiweb.ca"
            target="_blank"
            rel="noopener noreferrer"
            className="primary-btn hero-demo-btn"
          >
            Try the Visual Editor
          </a>

          <p className="hero-note">
            Free to explore. No sign up required.
          </p>

        </div>

      </header>


      {/* -------------------------
          Main
      ------------------------- */}

      <main className="main-section">

        {/* -------------------------
            Explore
        ------------------------- */}

        <section className="explore-section">

          <div className="section-heading">

            <h2>
              Explore the tools
            </h2>

            <p>
              Create visually, then bring AI into the parts you want to explore.
            </p>

          </div>


          <div className="feature-grid">

            <div className="feature-card">

              <div className="feature-icon">
                ✦
              </div>

              <h3>
                Visual Editor
              </h3>

              <p>
                Build your page visually and decide where AI can work.
              </p>

            </div>


            <div className="feature-card">

              <div className="feature-icon">
                AI
              </div>

              <h3>
                AI Creation
              </h3>

              <p>
                Generate content, images, code and creative elements
                within your layout.
              </p>

            </div>


            <div className="feature-card">

              <div className="feature-icon">
                ◇
              </div>

              <h3>
                SVG Editor
              </h3>

              <p>
                Create, edit and export scalable graphics.
              </p>

            </div>


            <div className="feature-card">

              <div className="feature-icon">
                ☺
              </div>

              <h3>
                OpenMoji
              </h3>

              <p>
                Explore and customize open-source emoji artwork.
              </p>

            </div>

            <div className="feature-card">
              <div className="feature-icon">
                A
              </div>
              <h3>
                Fonts
              </h3>
              <p>
                Explore open-source fonts and edit them to create your own designs.
              </p>
            </div>

            <div className="feature-card">

              <div className="feature-icon">
                &lt;/&gt;
              </div>

              <h3>
                HTML
              </h3>

              <p>
                View and experiment with the HTML your creations produce.
              </p>

            </div>

          </div>

        </section>


        {/* -------------------------
            Creator Plan
        ------------------------- */}

        <section className="creator-section">

          <div className="creator-card">

            <div className="creator-content">

              <div className="eyebrow">
                For when you want more
              </div>

              <h2>
                Creator Plan
              </h2>

              <p className="creator-description">
                Keep your work in the cloud, publish it online, and purchase
                AI credits when you want to use the AI features.
              </p>


              <ul>

                <li>
                  Personal cloud workspace
                </li>

                <li>
                  Upload and download your files
                </li>

                <li>
                  Save and continue editing projects
                </li>

                <li>
                  Publish your creations online
                </li>

                <li>
                  Purchase AI credits when you need them
                </li>

              </ul>


              <div className="creator-bottom">

                <div className="price">
                  $15
                  <span>
                    USD / month
                  </span>
                </div>

                <button
                  className="primary-btn"
                  onClick={handleJoinClick}
                >
                  Join Early Access
                </button>

              </div>

            </div>

          </div>

        </section>


        {/* -------------------------
            Closing
        ------------------------- */}

        <section className="closing-section">

          <h2>
            AI helps create. You remain in control.
          </h2>

          <p>
            Instead of asking AI to generate an entire website and then
            trying to take it back, you create the structure first and
            give AI a place to work.
          </p>

        </section>

      </main>


      {/* -------------------------
          Footer
      ------------------------- */}

      <footer className="footer">

        <a href="/docs">
          Documentation
        </a>

        <span>
          •
        </span>

        <span>
          Feedback?{" "}
          <a href="mailto:feedback@myaiweb.ca">
            feedback@myaiweb.ca
          </a>
        </span>

      </footer>

    </div>
  );
};

export default LandingPage;







/*
import React from 'react';
import './LandingPage.css';

const LandingPage = () => {
  const handleJoinClick = () => {
      alert("Not ready for sign ups yet");
     // window.location.href = '/signup';
  };
  return (
    <div className="landing-page">
      <header className="hero">
        <div className="header-top">
          <div className="logo">
            MyAIWeb
          </div>

          <div className="auth-buttons">
            <a href="/login" className="auth-btn">
              Login
            </a>
            <a href="/" className="auth-btn primary">
              Sign Up
            </a>
          </div>
        </div>

        <h1>
          Build Websites Visually. Create Faster with AI.
        </h1>

        <p>
          MyAIWeb is an AI-powered visual website builder where you design the
          structure and use AI to create content, images, and creative elements
          inside your layout.
        </p>

        <p>
          Instead of letting AI replace your vision, MyAIWeb gives you control over
          the design while AI helps you bring your ideas to life.
        </p>

        <p className="beta-note">
          Early access — helping shape a new way for humans and AI to create together.
        </p>

        <a
          href="https://ait.myaiweb.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="primary-btn hero-demo-btn"
        >
          Try the AI Website Editor
        </a>
      </header>

      <div className="content">
      <main className="main-section">
          <section className="about">
            <h2>
              A Different Way to Build for the Web
            </h2>

            <p>
              MyAIWeb is an all-in-one visual web creation tool for people who want
              to build and publish their own web experiences without having to
              become web developers.
            </p>

            <p>
              Instead of asking AI to generate an entire website and then trying to
              take control of the result, you design the page yourself. You decide
              where things go, how the page looks, and how it should behave. AI
              helps you create the content, graphics, code, and interactive
              experiences that bring your design to life.
            </p>

            <p>
              The result can be a traditional website, a highly visual digital
              poster, or something in between.
            </p>
          </section>

          <section className="features">
            <h2>
              Create More Than a Website
            </h2>

            <ul>
              <li>
                <strong>Design visually:</strong> Build pages using movable objects,
                layout areas, graphics, and compositions.
              </li>

              <li>
                <strong>Make your designs move:</strong> Draw paths and visually
                create animations that bring objects and artwork to life.
              </li>

              <li>
                <strong>Make parts of your page interactive:</strong> Add
                self-contained HTML, CSS, and JavaScript experiences inside
                designated areas of your design.
              </li>

              <li>
                <strong>Use AI as a creative partner:</strong> Generate images,
                content, code, animations, and interactive ideas without giving up
                control of the overall design.
              </li>

              <li>
                <strong>Work with your own assets:</strong> Use your images, SVGs,
                graphics, fonts, and other resources throughout your designs.
              </li>

              <li>
                <strong>Share your creations:</strong> Publish your website online
                and give it a web identity that others can visit.
              </li>

              <li>
                <strong>Share your work with others:</strong> Export templates that
                other people can use and build upon.
              </li>

              <li>
                <strong>Take your website with you:</strong> Export the complete
                website and host it somewhere else if you choose.
              </li>
            </ul>
          </section>

          <section className="how-it-works">
            <h2>
              How It Works
            </h2>

            <div className="steps">
              <div className="step">
                <h3>
                  1. Design
                </h3>
                <p>
                  Create your page visually. Arrange objects, images, text, graphics,
                  and layout areas exactly where you want them.
                </p>
              </div>

              <div className="step">
                <h3>
                  2. Bring It to Life
                </h3>
                <p>
                  Animate objects, draw motion paths, add interactive elements, or
                  ask AI to create HTML, CSS, and JavaScript for the spaces you've
                  designed.
                </p>
              </div>

              <div className="step">
                <h3>
                  3. Publish
                </h3>
                <p>
                  Publish your finished creation to the web. Keep editing it,
                  experiment with new ideas, and publish updates whenever you want.
                </p>
              </div>
            </div>
          </section>

          <section className="ownership">
            <h2>
              One Price. Your Work. Your Website.
            </h2>

            <p>
              MyAIWeb is designed around the individual creator. You get the complete
              creation environment rather than having to choose between increasingly
              restricted plans or upgrade whenever you want another capability.
            </p>

            <p>
              Your work is yours to continue developing, share with others, or export
              as a complete website. You can publish through your MyAIWeb web
              identity or take the files with you and host them elsewhere.
            </p>

            <ul>
              <li>
                One price for access to the complete tool.
              </li>
              <li>
                No feature tiers or forced upgrades.
              </li>
              <li>
                Automatically host and share your website online.
              </li>
              <li>
                Export complete websites for hosting elsewhere.
              </li>
              <li>
                Export templates so others can use and customize your work.
              </li>
              <li>
                Continue editing and improving your creations over time.
              </li>
            </ul>
          </section>

          <section className="audience">
            <h2>
              Built for Individual Creators
            </h2>

            <ul>
              <li>
                🎨 <strong>Visual Creators:</strong> People who think in posters,
                compositions, graphics, and visual layouts.
              </li>

              <li>
                ✨ <strong>Experimenters:</strong> People who want to explore what
                happens when visual design and AI creativity are combined.
              </li>

              <li>
                🖥️ <strong>Web Creators:</strong> People who want to make real,
                interactive websites without starting by learning to code.
              </li>

              <li>
                💻 <strong>Developers:</strong> People who want visual tools while
                retaining access to HTML, CSS, JavaScript, SVG, and the underlying
                website.
              </li>

              <li>
                🚀 <strong>Independent Builders:</strong> People who want one place
                to design, create, publish, share, and own their web projects.
              </li>
            </ul>
          </section>
      </main>
      <aside className="sidebar">
          <div className="pricing-card">
            <h3>
              Early Access
            </h3>
            <p>
              <strong>Interactive Demo:</strong>{" "}
              <a
                href="https://ait.myaiweb.ca"
                target="_blank"
                rel="noopener noreferrer"
              >
                Try the experimental editor
              </a>

              {" "}and explore the concept without signing up.
            </p>
            <p>
              <strong>Creator Plan:</strong> $15 USD/month for your website
              builder, hosting, and ongoing editing workspace.
            </p>
            <p>
              <strong>AI Credits:</strong> Use AI when you need extra
              creativity, generation, and assistance.
            </p>
            <button
              className="primary-btn"
              onClick={handleJoinClick}
            >
              Join Early Access
            </button>
          </div>
        </aside>
      </div>
      <footer className="footer">
        <p>
          <a href="/docs">
            Documentation
          </a>
        </p>
        <p>
          Feedback? Email{" "}
          <a href="mailto:feedback@myaiweb.ca">
            feedback@myaiweb.ca
          </a>
        </p>
      </footer>
    </div>
  );
};


export default LandingPage;
*/